module.exports = __webpack_public_path__ + "img/ic-success.ecf4476c.svg";